import { Link } from 'react-router-dom';
import { Disc, Music } from 'lucide-react';
import { cn } from '../../lib/cn.js';

interface AlbumCardProps {
  slug: string;
  title: string;
  artistName: string;
  artistSlug: string;
  coverUrl?: string | null;
  releaseYear?: number | null;
  songCount?: number;
  className?: string;
}

export function AlbumCard({
  slug,
  title,
  artistName,
  artistSlug,
  coverUrl,
  releaseYear,
  songCount,
  className,
}: AlbumCardProps) {
  return (
    <Link
      to={`/albums/${slug}`}
      className={cn(
        'group block rounded-xl overflow-hidden bg-surface hover:bg-surface-hover transition-all hover:shadow-lg hover:shadow-primary/5',
        className,
      )}
    >
      <div className="aspect-square relative overflow-hidden bg-surface-hover">
        {coverUrl ? (
          <img
            src={coverUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Disc size={40} className="text-text-muted" />
          </div>
        )}
      </div>
      <div className="p-3">
        <p className="text-sm font-semibold text-text-primary truncate group-hover:text-primary transition-colors">
          {title}
        </p>
        <Link
          to={`/artists/${artistSlug}`}
          className="text-xs text-text-secondary hover:text-primary transition-colors truncate block mt-0.5"
          onClick={(e) => e.stopPropagation()}
        >
          {artistName}
        </Link>
        <div className="flex items-center gap-2 mt-2 text-[10px] text-text-muted">
          {releaseYear && <span>{releaseYear}</span>}
          {songCount !== undefined && (
            <span className="flex items-center gap-0.5">
              <Music size={10} />
              {songCount}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
